var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chip"},[_c('div',{staticClass:"chip__label"},[_vm._v(" "+_vm._s(_vm.label)+" ")]),_c('button',{staticClass:"chip__close",on:{"click":function($event){return _vm.$emit('close')}}},[_c('IconDeleteChip')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }